var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_1914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 23.6476H33.401L47.2951 9.75347L43.2465 5.70486L29.3524 19.599V0H23.6476V19.599L9.75347 5.70486L5.70486 9.75347L19.599 23.6476H0V29.3524H19.599L5.70486 43.2465L9.75347 47.2951L23.6476 33.401V53H29.3524V33.401L43.2465 47.2951L47.2951 43.2465L33.401 29.3524H53V23.6476Z",
    fill: "#B07EF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_1914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPurple);
export default __webpack_public_path__ + "static/media/starPurple.8d4f4ee0681ded064b7a2cbb2995be80.svg";
export { ForwardRef as ReactComponent };